var _ = require("../../uam/module.js")(module.exports, {
  namespace: "egt.contact.thanks",
  title: "EGT Contact — Thank you",
  description: "On-brand contact success state; restates the one-business-day SLA.",
  supportServer: true
});
var S = require("../helpers/egt.sections.js");

/* The contact success state, rebranded from the old keynote-hero__* markup to
 * the canvas/glass system. A frosted card on the warm About canvas, Playfair
 * "Thank you," and a restated response-time SLA (premium success-state rule).
 * Media UNDIMMED; contrast from the glass card only. */
exports.render = async function render() {
  return S.page("/reserve", [
    { n: "section", c: "egt-section egt-canvas egt-canvas--center egt-canvas--tall egt-contact-thanks",
      i: [
        S.media({ img: "/imgs/egt-about-canvas.jpg", alt: "", parallax: 0.08, priority: true }),
        { n: "div", c: "egt__shell egt-canvas__inner egt-contact-thanks__inner",
          i: S.glass({ width: "wide", tone: "dark", c: "egt-contact-thanks__card egt-reveal",
            content: [
              { n: "p", c: "egt__eyebrow", i: "Message received" },
              { n: "h1", c: "egt-contact-thanks__title", i: "Thank you." },
              { n: "p", c: "egt-contact-thanks__lead",
                i: "Your message is in — verified and straight to us. We reply within one business day." },
              { n: "div", c: "egt-contact-thanks__actions",
                i: [
                  S.cta("/", "Return home"),
                  { n: "a", href: "/about", c: "egt-cta egt-cta--ghost",
                    i: [ "Our story", { n: "span", c: "egt-cta__tick", i: "›" } ] }
                ] }
            ] }) }
      ] }
  ]);
};
